import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["image", "altText", "imageAsBackground", "content", "children", "className", "imagePosition", "disabled"];
import React from 'react';
import { RIGHT_ORIENTATION, LEFT_ORIENTATION } from './HorizontalImageCard.constants';
import { ImagePropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { withEvent } from '../../../../../analytics/components/Event';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import ImageCard from '../../ImageCard';
import './HorizontalImageCard.less';
var defaultProps = {
  image: null,
  altText: '',
  imageAsBackground: false,
  content: null,
  children: null,
  className: '',
  imagePosition: RIGHT_ORIENTATION,
  disabled: false
};
function HorizontalImageCard(_ref) {
  var image = _ref.image,
    altText = _ref.altText,
    imageAsBackground = _ref.imageAsBackground,
    content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    imagePosition = _ref.imagePosition,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getCardProps = _useSemanticUiProps.getCardProps;
  var finalContent = content || children;
  var finalClassName = classNames(_defineProperty({
    'horizontal-image-card': true
  }, className, className));
  var cardProps = getCardProps(rest);
  return /*#__PURE__*/React.createElement(ImageCard, _extends({
    className: finalClassName,
    disabled: disabled
  }, cardProps), imagePosition !== RIGHT_ORIENTATION && /*#__PURE__*/React.createElement(ImageCard.Image, {
    src: image,
    altText: altText,
    background: imageAsBackground
  }), /*#__PURE__*/React.createElement(ImageCard.Content, null, finalContent), imagePosition === RIGHT_ORIENTATION && /*#__PURE__*/React.createElement(ImageCard.Image, {
    src: image,
    altText: altText,
    background: imageAsBackground
  }));
}
HorizontalImageCard.defaultProps = defaultProps;
export default withEvent('click')(HorizontalImageCard);